import api from "./api";
import { asList, parsePaginatedList } from "../utils/pagination";

export interface Branch {
  id: string;
  name: string;
  address?: string;
  phone?: string;
  email?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface BranchStats {
  totalUsers: number;
  totalCardHolders: number;
  totalTransactions: number;
  totalRecharges: number;
  totalRevenue: number;
  totalSalesPoints: number;
}

export interface CreateBranchData {
  name: string;
  address: string;
  phone: string;
  email: string;
}

export interface UpdateBranchData {
  name?: string;
  address?: string;
  phone?: string;
  email?: string;
  isActive?: boolean;
}

export interface BranchStats {
  totalUsers: number;
  totalCardHolders: number;
  totalTransactions: number;
  totalRevenue: number;
  totalSalesPoints: number;
}

const branchAPI = {
  // Get all branches with pagination
  getBranches: async (params?: {
    pageNo?: number;
    pageSize?: number;
    search?: string;
    isActive?: boolean;
    sortBy?: string;
    sortOrder?: "ASC" | "DESC";
  }): Promise<{ data: Branch[]; total: number }> => {
    const response = await api.get("/branches", { params });
    const { data, total } = parsePaginatedList<Branch>(response.data.data);
    return { data, total };
  },

  // Get branch by ID
  getBranchById: async (id: string): Promise<Branch> => {
    const response = await api.get(`/branches/${id}`);
    return response.data.data;
  },

  // Create new branch
  createBranch: async (data: CreateBranchData): Promise<Branch> => {
    const response = await api.post("/branches", data);
    return response.data.data;
  },

  // Update branch
  updateBranch: async (id: string, data: UpdateBranchData): Promise<Branch> => {
    const response = await api.put(`/branches/${id}`, data);
    return response.data.data;
  },

  // Delete branch
  deleteBranch: async (id: string): Promise<void> => {
    await api.delete(`/branches/${id}`);
  },

  // Get branch statistics
  getBranchStats: async (id: string): Promise<BranchStats> => {
    const response = await api.get(`/branches/${id}/stats`);
    return response.data.data;
  },

  // Get all branches without pagination (for dropdowns)
  getAllBranches: async (): Promise<Branch[]> => {
    const response = await api.get("/branches/all");
    return asList<Branch>(response.data.data);
  },
};

export { branchAPI };
